module.exports = __webpack_public_path__ + "img/pdf.e8f760b1.svg";